/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-06-06 15:42:22
 */
import React from 'react'
import { Button, Modal } from 'antd'
import customer_edit_img from '../../../images/customer-edit.png'
import sensors from 'sa-sdk-javascript'
import { useAppSelector } from '../../../app/hooks'

export default ({ visible, onClose }) => {
  const customerConfig = useAppSelector((state) => state.group.customerConfig)

  const reportSaClickEvent = (clickItem) => {
    sensors.track('web_click_pop_edit_customer_info_feedback', {
      clickItem
    })
  }

  return (
    <Modal open={visible} footer={null} getContainer={false} closable={false}>
      <div className="edit-container">
        <div className="title">{customerConfig.noun}信息编辑</div>
        <div className="subtitle">该功能正在抓紧开发中</div>
        <img src={customer_edit_img} className="img" />
        <div className="footer">
          <Button
            className="btn"
            onClick={() => {
              reportSaClickEvent('clickOK')
              onClose()
            }}
          >
            好的
          </Button>
          <Button
            className="btn"
            type="primary"
            onClick={() => {
              reportSaClickEvent('clickUrge')
              onClose()
            }}
          >
            催促开发
          </Button>
        </div>
      </div>
    </Modal>
  )
}
